import type { GuestQuoteLinkParams } from '@repo/api-contracts';
import type { ReactElement } from 'react';
import { Button } from '@/shared/ui';
import { useOrderGuestQuote } from '../model/use-order-guest-quote';

interface GuestQuoteOrderButtonProps {
  readonly params: GuestQuoteLinkParams;
  /** 놓이는 자리에 맞춘 크기·폭 — 링크 화면이 넘긴다. */
  readonly className?: string;
}

/** 링크 화면 [주문하기](결정 G11) — 연결 대상을 기억하고 로그인 화면·온보딩으로 보내거나, ACTIVE 회원이면 바로 연결한다. */
export const GuestQuoteOrderButton = ({
  params,
  className,
}: GuestQuoteOrderButtonProps): ReactElement => {
  const { order, isPending } = useOrderGuestQuote(params);

  return (
    <Button
      type="button"
      size="lg"
      className={className}
      isLoading={isPending}
      onClick={() => {
        void order();
      }}
    >
      주문하기
    </Button>
  );
};
